<template>
    <div class="flex flex-row w-full min-h-screen items-center gap-0">
        <div class="grid grid-cols-12 w-full min-h-screen items-center">
            <div class="col-span-9 sm:col-span-9">
                <AppCartList />
            </div>
        
            <div class="col-span-3 sm:col-span-3">        
                <div class="w-80 bg-white rounded-lg border border-gray-200 shadow-sm p-8 flex flex-col items-center text-center">   
                    <p class="text-gray-500 mb-2">Total Items</p>
                    <h4 class="text-3xl font-bold mb-6" > {{ caltotalitem }} </h4>
                    <p class="text-gray-500 mb-2">Total Payment</p>
                    <h3 class="text-4xl font-bold mb-8">$ {{ caltotalcost }}</h3>
                    <hr class="w-full border-gray-200 mb-8" />
                    <div class="flex flex-col w-full gap-3">
                        <Button>CHECKOUT</Button>
                        <Button>CLEAR</Button>
                    </div>
                </div>
            </div>
            `
        </div>
    </div>
</template>
<script>
import { useUserCartStore } from '../store/storecart.js';
import Button from "primevue/button";
//import PlusCircleIcon from '../utils/iconsindex.js';
import 'primeicons/primeicons.css'
import AppCartList from './cartlist.vue'
export default {
    name: 'AppCart', 
    components: {
        Button,
        //PlusCircleIcon,
        //PlusIcon
        AppCartList
    },
    data() {
        return {
            cartdatas: [],
            totalitem: 0,
            totalcost: 0
        };
    },
    computed: {
        calcartdatas() {
            return useUserCartStore().cartData;
        },
        caltotalitem() {
            return useUserCartStore().totalCount;
        },
        caltotalcost() {
            return Number(useUserCartStore().totalAmount.toFixed(1));
        }
    },
    methods: {    
        async getcartitem() {
            const cartStore = useUserCartStore();
            this.cartdatas = cartStore.cartData;
            console.log(this.cartdatas.cartData);
        },
        addcart() {
            console.log("addcartquantity");

        },
        increasequantity(cartitem)
        {
            console.log('increasequantity(cartitemdata)');
            console.log(cartitem);
            useUserCartStore().increasecartitem(cartitem)
            this.totalcost = useUserCartStore.totalcost
            this.calculateTotals();
        },
        decreasequantity(cartitem)
        {
            console.log('decreaasequantity(cartitemdata)');
            console.log(cartitem);
            useUserCartStore().decreasecartitem(cartitem)
            this.calculateTotals();
        }
    },
    mounted() {
        this.getcartitem();
        console.log("mounted");
    }
}
</script>

<!-- 
            <div v-for="cartdata in source">

            </div>
-->
